const URL = require('@/assets/avatar.png')
class imgBind {
  constructor(imgs, options) {
    this.source = imgs;
    this.options = Object.assign({
      default: URL,
      width: 160,
      height: 160,
      gutter: 5,
      background: '#fff',
    }, options);
    this._init()
  }
  _init() {
    let { width, height, gutter, background } = this.options;
    let l = this.source.length;
    if (l > 1 && l < 5) { l = 2 }
    if (l > 4 && l < 10) { l = 3 }
    this._width = (width - gutter) / l - gutter;
    this._height = this._width;
    this._canvas = document.createElement('canvas');
    this._canvas.width = width;
    this._canvas.height = height;

    let ctx = this._canvas.getContext('2d');
    ctx.beginPath();
    ctx.lineWidth = "0";
    ctx.fillStyle = background;
    ctx.rect(0, 0, width, height);
    ctx.fill();
    let arr = []
    this.source.forEach(item => {
      if (!item) {
        arr.push(this.options.default)
      } else {
        arr.push(item)
      }
    });
    this.source = arr;
  }
  async loadImage() {
    return new Promise((resolve, reject) => {
      try {
        let count = 0;
        for (let key in this.source) {
          const imgurl = this.source[key] || this.options.default;
          const image = new Image();
          image.setAttribute('crossOrigin', 'anonymous');
          image.onload = (event) => {
            count++;
            let { sx, sy } = this.calcOffset(+key);
            this._canvas.getContext('2d').drawImage(image, sx, sy, this._width, this._height);
            if (count === this.source.length) {
              resolve(this._canvas.toDataURL("image/png"))
            }
          }
          image.src = imgurl;
        }
      } catch (e) {
        console.log('err in', e)
        reject(e)
      }
    })
  }
  calcOffset(key) {
    let { width, height, gutter } = this.options;
    let sx = 0, sy = 0;
    switch (this.source.length) {
      case 2: {
        sx = gutter + (this._width + gutter) * (key % 3);
        sy = (height - this._height) / 2;
        break;
      }
      case 3: {
        if (key === 0) {
          sx = (width - this._width) / 2;
          sy = gutter + (this._height + gutter) * (key - key % 3) / 3;
        } else {
          let k = key - 1;
          sx = gutter + (this._width + gutter) * (k % 3);
          sy = gutter + (this._height + gutter) * 1;
        }
        break;
      }
      case 5: {
        if (key === 0 || key === 1) {
          sx = gutter + (this._width + gutter) * (key % 3) + (width - gutter * 3 - this._width * 2) / 2;
          sy = gutter + (height - gutter * 3 - this._height * 2) / 2;
        } else {
          key = key - 2;
          sx = gutter + (this._width + gutter) * (key % 3);
          sy = gutter + (this._width + gutter) + (height - gutter * 3 - this._height * 2) / 2;
        }
        break;
      }
      case 6: {
        sx = gutter + (this._width + gutter) * (key % 3);
        sy = gutter + (this._height + gutter) * (key - key % 3) / 3 + (height - gutter * 3 - this._height * 2) / 2;
        break;
      }
      case 7: {
        if (key === 0) {
          sx = (width - this._width) / 2;
          sy = gutter;
        } else {
          key = key + 2;
          sx = gutter + (this._width + gutter) * (key % 3);
          sy = gutter + (this._height + gutter) * (key - key % 3) / 3;
        }
        break;
      }
      case 8: {
        if (key === 0 || key === 1) {
          sx = gutter + (this._width + gutter) * (key % 3) + (width - gutter * 3 - this._width * 2) / 2;
          sy = gutter;
        } else {
          key = key + 1;
          sx = gutter + (this._width + gutter) * (key % 3);
          sy = gutter + (this._height + gutter) * (key - key % 3) / 3;
        }
        break;
      }
      default: {
        let k = Math.sqrt(this.source.length)
        sx = gutter + (this._width + gutter) * (key % k);
        sy = gutter + (this._height + gutter) * (key - key % k) / k;
      }
    }
    return { sx, sy }
  }

}
export default imgBind
